import { HStack, VStack } from "goi_common";

interface Row {
  key: string;
  value: string;
}

interface Props {
  rows: Row[];
}

const NonBorderTable = ({ rows }: Props) => {
  return (
    <VStack as="table">
      <VStack as="tbody" gap="8px" className="body3_m">
        {rows.map((row) => (
          <HStack as="tr" className="body_14_m" key={row.key}>
            <td css={{ flex: 1 }}>{row.key}</td>
            <td css={{ flex: 1 }}>{row.value}</td>
          </HStack>
        ))}
      </VStack>
    </VStack>
  );
};

export default NonBorderTable;
